import clsx from 'clsx'
import React from 'react'
import {useIntl} from 'react-intl'
import {useLocation} from 'react-router'

import {KTIcon, hasActiveSubLink} from '_metronic/helpers'
import {useLayout} from '_metronic/layout/core'

import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarLinkWithSubs} from './types'

const SidebarMenuItemWithSub: React.FC<SidebarLinkWithSubs> = ({
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
  visible = true,
  subLinks,
  badgeColor = 'light-primary',
  badgeLabel,
}) => {
  const intl = useIntl()
  const {pathname} = useLocation()
  const isActive = hasActiveSubLink(subLinks, pathname)
  const {config} = useLayout()
  const {app} = config

  const titleHasTranslation = title ? !!intl.messages[title] : false
  const badgeLabelHasTranslation = badgeLabel ? !!intl.messages[badgeLabel] : false

  if (!visible) return null

  return (
    <div
      className={clsx('menu-item', {'here show': isActive}, 'menu-accordion')}
      data-kt-menu-trigger='click'
    >
      <span className='menu-link'>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <span className='menu-icon'>
            <i className={clsx('fs-3 me-3', fontIcon)}></i>
          </span>
        )}
        <span className='menu-title'>
          {titleHasTranslation ? intl.formatMessage({id: title}) : title}
          {badgeLabel && (
            <span className={clsx('ms-2', 'badge', `badge-${badgeColor}`)}>
              {badgeLabelHasTranslation ? intl.formatMessage({id: badgeLabel}) : badgeLabel}
            </span>
          )}
        </span>
        <span className='menu-arrow'></span>
      </span>
      <div className={clsx('menu-sub menu-sub-accordion', {'menu-active-bg': isActive})}>
        {subLinks &&
          subLinks.map((link, j) => {
            if (link.subLinks) {
              return <SidebarMenuItemWithSub {...link} key={`${j}-${link.to ?? Math.random()}`} />
            }
            return <SidebarMenuItem {...link} key={`${j}-${link.to ?? Math.random()}`} />
          })}
        {!subLinks && (
          <SidebarMenuItem {...{to, title, icon, fontIcon, hasBullet, visible}} key={to} />
        )}
      </div>
    </div>
  )
}

export {SidebarMenuItemWithSub}
